import { render } from "./FormPaymentsBank.vue?vue&type=template&id=140c812c&scoped=true"
import script from "./FormPaymentsBank.vue?vue&type=script&lang=js"
export * from "./FormPaymentsBank.vue?vue&type=script&lang=js"

import "./FormPaymentsBank.vue?vue&type=style&index=0&id=140c812c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140c812c"]])

export default __exports__